<template>
  <div class="n-card-title">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: `NCardTitle`,
};
</script>

<style lang="scss" scoped>
  .n-card-title {
    margin-top: 10px;
    font-weight: 500;
    font-size: .9rem;
    color: #666;
  }
</style>
